<template>
  <PricingView />
</template>

<script>
import LoggerFactory from '@/services/utils/LoggerFactory';
const logger = LoggerFactory.getLogger('_name.vue');
import pageCommonMixin from '@/components/mixins/pageCommonMixin';
import PricingView from '@/components/pages/Pricing/Pricing.vue';
export default {
  name: 'PricingPage',
  components: {
    PricingView
  },
  mixins: [pageCommonMixin],
  async asyncData({ store }) {
    try {
      const { link } = await store.dispatch(
        'ContextStore/getPricingPageHeadInfo'
      );
      return { link };
    } catch (error) {
      logger.fatal(`Get error on create pricing page error: ${error}`);
    }
  },
  head() {
    const headSettings = this.getCommonHeadSettings();
    return {
      ...headSettings,
      title: 'WholeReader: Pricing',
      link: this.link
    };
  }
};
</script>

<style></style>
